var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2499 7V15.1895L9.53022 13.4697C9.23732 13.1768 8.76256 13.1768 8.46967 13.4697C8.17678 13.7626 8.17678 14.2374 8.46967 14.5303L11.4697 17.5303L11.5263 17.582C11.8209 17.8223 12.2556 17.8049 12.5302 17.5303L15.5302 14.5303C15.8231 14.2374 15.8231 13.7626 15.5302 13.4697C15.2373 13.1768 14.7626 13.1768 14.4697 13.4697L12.7499 15.1895V7C12.7499 6.58579 12.4142 6.25 11.9999 6.25C11.5857 6.25 11.2499 6.58579 11.2499 7Z",
    fill: "currentColor"
  })));
};
export default SvgArrowDown;